import { createSlice } from '@reduxjs/toolkit'

import { depotsAdapter } from './depotsAdapters'
import { saveDepot } from './thunks/saveDepot'
import { toggleDepotStatus } from './thunks/toggleDepotStatus'

export const initialDepotState = depotsAdapter.getInitialState()

export const depotsSlice = createSlice({
  name: 'depots',
  initialState: initialDepotState,
  reducers: {
    upsertMultipleDepots: (state, action) => {
      depotsAdapter.upsertMany(state, action.payload)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(toggleDepotStatus.fulfilled, (state, action) => {
        const id = action.payload

        if (!id) return

        const depot = state.entities[id]

        if (depot) {
          depot.isActive = !depot.isActive
        }
      })
      .addCase(saveDepot.fulfilled, (state, action) => {
        depotsAdapter.upsertOne(state, action.payload)
      })
  },
})

export const { upsertMultipleDepots } = depotsSlice.actions